import { useState, useCallback, useMemo } from 'react';

const getSortValue = (obj, field) => {
  if (!obj) return null;
  const parts = field.split('.');
  let v = obj;
  for (const p of parts) {
    if (v == null) return null;
    v = v[p];
  }
  if (v == null) return null;
  if (typeof v === 'object') {
    if (typeof v.seconds === 'number') return v.seconds;
    if (typeof v.toDate === 'function') {
      try { return v.toDate().getTime(); } catch { return null; }
    }
    if (Array.isArray(v)) return v.length;
  }
  return v;
};

const compareValues = (av, bv) => {
  if (av == null && bv == null) return 0;
  if (av == null) return 1;
  if (bv == null) return -1;
  if (typeof av === 'number' && typeof bv === 'number') return av - bv;
  if (typeof av === 'boolean' && typeof bv === 'boolean') return (av === bv) ? 0 : av ? 1 : -1;
  const as = String(av).toLowerCase();
  const bs = String(bv).toLowerCase();
  if (as < bs) return -1;
  if (as > bs) return 1;
  return 0;
};

const useTableSort = (initialField = null, initialDir = 'desc') => {
  const [sortField, setSortField] = useState(initialField);
  const [sortDir, setSortDir] = useState(initialDir);

  const onSort = useCallback((field) => {
    if (!field) return;
    setSortField(prev => {
      if (prev === field) {
        setSortDir(d => (d === 'asc' ? 'desc' : 'asc'));
        return prev;
      }
      setSortDir('asc');
      return field;
    });
  }, []);

  const sortItems = useCallback((items) => {
    if (!Array.isArray(items) || !sortField) return items;
    const sorted = [...items].sort((a, b) => {
      const av = getSortValue(a, sortField);
      const bv = getSortValue(b, sortField);
      const cmp = compareValues(av, bv);
      return sortDir === 'desc' ? -cmp : cmp;
    });
    return sorted;
  }, [sortField, sortDir]);

  const ctxValue = useMemo(() => ({ sortField, sortDir, onSort }), [sortField, sortDir, onSort]);

  return { sortField, sortDir, onSort, sortItems, ctxValue };
};

export default useTableSort;
